import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
	root: {
		position: "relative",
		width: "262px",
	},
	tariffName: {},
	benefitsList: {
		marginTop: "12px",
	},
	shortDescription: {
		marginTop: "8px",
		fontSize: "16px",
		color: theme.palette.colors.darkSlateBlue,
	},
	dodyList: {
		marginTop: "6px",
	},
	[`@media (min-width: ${theme.media.lg})`]: {
		tariffName: {
			width: "242px",
		},
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		root: {
			width: "238px",
		},
		tariffName: {
			width: "215px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			width: "150px",
		},
		tariffName: {
			width: "118px",
		},
		shortDescription: {
			fontSize: "14px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			width: "100%",
		},
		tariffName: {
			maxWidth: "100%",
		},
	},
}));

const TariffInfo = ({ tariffName, benefitsList, shortDescription, dodyList }) => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<div className={classes.tariffName}>{tariffName}</div>
			{!!shortDescription && <div className={classes.shortDescription}>{shortDescription}</div>}
			{benefitsList && <div className={classes.benefitsList}>{benefitsList}</div>}
			{dodyList && <div className={classes.dodyList}>{dodyList}</div>}
		</div>
	);
};

export default TariffInfo;
